import { REQUEST_ERROR, REQUEST_SUCCESS } from '../../../../../../middlewares/api/actions';
import {
    FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PREVIEW_GET,
    FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_SHOW,
    FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_HIDE,
    FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_DOWNLOAD
} from './actions';

const fileMappingWizardPreviewRowListReducer = (
  state = {
    isVisible: false,
    previewRows: null,
    isFixed: false
  },
  action
) => {
  switch (action.type) {
    case FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_SHOW:
      return {
        ...state,
        isVisible: true,
        isFixed: action.fixed
      };
    
    case REQUEST_ERROR:
      switch (action.label) {
        case FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_DOWNLOAD:
          return {
            ...state
          };
        case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PREVIEW_GET:
          return {
            ...state,
            isVisible: false,
            previewRows: null,
            isFixed: false
          };
        case FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_HIDE:
          return {
            ...state,
            isVisible: false,
            previewRows: null,
            isFixed: false
          };
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_DOWNLOAD:
          return {
            ...state
          };
        case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PREVIEW_GET:
          return {
            ...state,
            previewRows: action.response
          };
        case FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_HIDE:
          return {
            ...state,
            isVisible: false,
            previewRows: null,
            isFixed: false
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export default fileMappingWizardPreviewRowListReducer;
